import { render, staticRenderFns } from "./common_job.vue?vue&type=template&id=f1a80ef6&scoped=true"
import script from "./common_job.vue?vue&type=script&lang=js"
export * from "./common_job.vue?vue&type=script&lang=js"
import style0 from "./common_job.vue?vue&type=style&index=0&id=f1a80ef6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a80ef6",
  null
  
)

export default component.exports